import React, { lazy, Suspense } from 'react'
import Loader from 'view/component/loader'

const SuspenseComponent = (props, LazyComponent) => (
  <Suspense fallback={<Loader />}>
    <LazyComponent {...props} />
  </Suspense>
)

export default (importFunc) => {
  const LazyComponent = lazy(importFunc)

  return (props) => SuspenseComponent(props, LazyComponent)
}
